import * as React from "react";
import styled from "styled-components";
import { HTMLProps, ReactNode } from "react";
import { Text } from "src/components";

type Props = {
  children: ReactNode;
  ordered?: boolean;
};

const UnorderedListEl = styled.ul`
  list-style: disc;
  margin: 0px;
  padding: 0 20px;
`;

const OrderedListEl = styled.ol`
  list-style: unset;
  padding: inherit;
`;

export const List: React.FC<Props> = ({ children, ordered }) => {
  if (ordered) {
    return <OrderedListEl>{children}</OrderedListEl>;
  }

  return <UnorderedListEl>{children}</UnorderedListEl>;
};

export const ListItem: React.FC<HTMLProps<HTMLDataListElement>> = ({
  children,
}) => {
  return (
    <Text as="li" fontWeight="book" fontSize="normal" marginBottomL>
      {children}
    </Text>
  );
};
